import Check from './Check';
import Nayose from './Nayose';

export default {
  Check,
  Nayose,
};
